
const url = 'events-items';

export const itemRoutes = {
  list: `/admin/${url}`,
};

